import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { GlobalDataBusService } from "./global-data-bus.service";
import { environment as config } from "src/environments/environment";

import { QdReturnType} from "src/app/infrastructure/qd-return-type";

// import * as idbFn from '../shared/services/idb.functions';
@Injectable()
export class srvThemeLoader {
  constructor(private httpClient: HttpClient) {}
  initializeApp(): Promise<any> {
    return new Promise((resolve, reject) => {

      setTimeout(() => {
        resolve(true);
      }, 3000);
    });
  }

  getMasterDataCollection() {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    const promise = this.httpClient
      .post(`${config.apiBaseUrl}MasterData/masterDataCollection`, 'master', httpOptions)
      .toPromise()
      .then((Response: QdReturnType) => {
        localStorage.setItem("MasterData", JSON.stringify(Response.Payload));
        return Response;
      });
    return promise;
  }

  getIpAddress(): Promise<any> {
    const promise = this.httpClient
      .get(`https://ipinfo.io/?token=${config.QdIpfetchToken}`)
      .toPromise()
      .then((Response: any) => {
        GlobalDataBusService.appIPAddress = Response.ip;
        GlobalDataBusService.appCountryCode = Response.country;
        return Response;
      });
    return promise;
  }

  getTheme(): Promise<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    const promise = this.httpClient
      .post(`${config.apiBaseUrl}MasterData/appTheme`, "theme", httpOptions)
      .toPromise()
      .then((Res: QdReturnType) => {
        if (Res.Success) {
          if (Res.Payload != undefined && Res.Payload.length > 0) {
            var theme = Res.Payload[0].theme;
            try {
              GlobalDataBusService.appSettings = JSON.parse(Res.Payload[0].appSettings)
            } catch (error) { }
            GlobalDataBusService.appLogoProfile = Res.Payload[0].appLogoProfile;
            GlobalDataBusService.appLogo = Res.Payload[0].appLogo;
            GlobalDataBusService.appName = Res.Payload[0].appName;
            if (theme && theme != "") {
              localStorage.setItem("theme", theme);
              GlobalDataBusService.bacicTheme = JSON.parse(theme);
              if (
                GlobalDataBusService.bacicTheme != undefined &&
                GlobalDataBusService.bacicTheme.length > 0
              ) {
                GlobalDataBusService.bacicTheme.forEach((th) => {
                  document.body.style.setProperty(`--${th.Key}`, th.Value);
                });
              }
            }
          }
        }

        return Response;
      });

    return promise;
  }

}
